import type { Organization } from '@/domain/organization'
import type { OrganizationRepository } from '@/repositories/OrganizationRepository'
import { seedOrganizations } from '@/data/seed/organizations'

export class LocalOrganizationRepository implements OrganizationRepository {
  async list(): Promise<Organization[]> {
    return seedOrganizations
  }

  async getById(id: string): Promise<Organization | null> {
    return seedOrganizations.find((o) => o.id === id) ?? null
  }
}
